import axios, { CancelTokenSource } from 'axios';
import { Location, ResourceDto, ResourcesSearchDto, TreaterDto, UpsertResourceDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUrl = `${baseUrl}/api/resources`;

export const getAllResources = (
    source: CancelTokenSource): Promise<Array<ResourceDto>> => {

  return axios
      .post(apiUrl, {cancelToken: source.token})
      .then((response) => response.data);
};

export const getAllLocations = (
    source: CancelTokenSource): Promise<Array<Location>> => {

  return axios
      .get(`${apiUrl}/locations`, {cancelToken: source.token})
      .then((response) => response.data);
};

export const getResourceById = (
    id: number, source: CancelTokenSource): Promise<UpsertResourceDto> => {

  return axios
      .get(`${apiUrl}/${id}`, {cancelToken: source.token})
      .then((response) => response.data);
}

export const getMandateResources = (
    mandateId: number,
    source: CancelTokenSource): Promise<Array<ResourceDto>> => {

  return axios
      .get(`${apiUrl}/mandate/${mandateId}`, {cancelToken: source.token})
      .then((response) => response.data);
}

export const getAllEligibleTreaters = (
    id: number | string,
    source: CancelTokenSource): Promise<TreaterDto[]> => {

  return axios
      .get(`${apiUrl}/${id}/treaters`, {cancelToken: source.token})
      .then((response) => response.data);
}

export const saveResource = (
    upsertResourcesDto: Partial<UpsertResourceDto>,
    source: CancelTokenSource): Promise<ResourceDto> => {

  return axios
      .post(`${apiUrl}/add`, upsertResourcesDto, {cancelToken: source.token})
      .then((response) => response.data);
};

export const editResource = (
    id: number, upsertResourcesDto: Partial<UpsertResourceDto>,
    source: CancelTokenSource): Promise<ResourceDto> => {

  return axios
      .put(`${apiUrl}/${id}`, upsertResourcesDto, {cancelToken: source.token})
      .then((response) => response.data);
};

export const deleteById = (
    id: number, source: CancelTokenSource): Promise<ResourceDto> => {

  return axios
      .delete(`${apiUrl}/${id}`, {cancelToken: source.token})
      .then((response) => response.data);
};

export const searchResource = (
    searchTerm: Partial<ResourcesSearchDto>,
    source: CancelTokenSource): Promise<Array<ResourceDto>> => {

  return axios
      .post(`${apiUrl}/search`, searchTerm, {cancelToken: source.token})
      .then(response => response.data)
};
